// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
import { select2RemoteAjax } from './select2_remote';

(function() {

$(document).on("turbo:load", function() {
  $("#address_zipcode").jpostal({
    postcode : [ "#group_postal_code" ],
    address  : {
      "#group_address" : "%3%4%5%6%7"
    }
  });

  if ($('#group_admin_user_id').is(':visible')) {
    $('#group_admin_user_id').select2(user_select('Lawyer', false));
  }
  $('#group_lawyer_ids').select2(user_select('Lawyer', true));
  $('#group_secretary_ids').select2(user_select('Secretary', true));
  $('#group_matter_access_type').select2({allowClear: false, placeholder: '選択してください'});
  $('#group_contact_access_type').select2({allowClear: false, placeholder: '選択してください'});
});

const user_select = (type, multiple) => ({
  language: "ja",
  allowClear: true,

  ajax: select2RemoteAjax({
    url: "/users.json",
    query: params => ({ auth_mail_or_ms_mail_eq: params.term }),
    extra: () => ({ type })
  }),

  // let our custom formatter work
  escapeMarkup(markup) { return markup; },

  minimumInputLength: 6,
  multiple,
  placeholder: 'ユーザー検索'
});

const ajax_select = {
  language: "ja",
  allowClear: true,
  ajax: select2RemoteAjax({
    url: "/users.json",
    query: params => ({ auth_mail_start_or_ms_mail_eq: params.term })
  }),
  escapeMarkup(markup) { return markup; }, // let our custom formatter work
  minimumInputLength: 6
};

const ajax_multi_select = jQuery.extend({multiple:true, placeholder: '連絡先検索'}, ajax_select);

})();
